import React from 'react';
import clsx from 'clsx';
import { MenuItemProps } from 'interfaces/menu_item.interface';
import './menu_item.ui.scss';

const MenuItem = (props: MenuItemProps): React.ReactElement => {
  const { icon, label, onClick, isDanger = false, className } = props;

  return (
    <button
      type="button"
      role="menuitem"
      className={clsx('menu_item', isDanger && 'menu_item_danger', className)}
      onClick={onClick}>
      <img className="menu_item_icon" src={icon} alt="" />
      <span className="menu_item_title">{label}</span>
    </button>
  );
};

export default MenuItem;
